import React, { useEffect, useRef, useState } from "react";
import { Formik, Field } from "formik";
import Form, { InputSection } from "../components/Form";
import Input from "../../../ui/Input";
import { DropDown } from "../../../ui/DropDown";
import { GetHook, postEndpoint, putEndpoint } from "../../../api/api";
import {
  PERIOD_URL,
  SCORECARD_URL,
  USER_URL,
  STRATEGYMAP_URL,
} from "../../../api/urls";
import { parseDropdown } from "../../../utils/parseDropdown";
import { get } from "../../../utils/get";
import Axios from "axios";
import styled from "styled-components";
import { TitleText, LabelText } from "../../../ui/Text";
import { AttendeeCard } from "../../../components/AttendeeCard";
import Modal from "../../../ui/Modal";
import SearchInput from "../../../ui/SearchInput";
import { EditIcon } from "../../../assets/svg/EditIcon";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

interface IProps {
  closeModal?: any;
  setHandleSubmit?: any;
  setScorecards?: any;
  scorecards?: any;
  editData?: any;
}

const AddStrategymapForm = ({
  closeModal,
  setHandleSubmit,
  setScorecards,
  scorecards,
  editData,
}: IProps) => {
  const [postRes, postStrategymap] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();
  const formRef: any = useRef<any>(null);
  const { data: period } = GetHook(`${PERIOD_URL}`);
  const { data: users } = GetHook(USER_URL);
  const { id } = editData;
  const isAddMode = !id;

  const periodOptions = parseDropdown(period);
  const scorecardOptions = parseDropdown(scorecards);

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  useEffect(() => {
    setHandleSubmit(() => handleSubmit);
    return () => {};
  }, []);

  const [openModal, setOpenmodal] = useState(false);
  const [owner, setOwner] = useState(
    !isAddMode && {
      id: get(editData, "owner_id", undefined),
    }
  );
  const addManager = () => {
    setOpenmodal(!openModal);
  };

  const submitForm = (values) => {
    const payload = {
      name: get(values, "name"),
      scorecard_id: get(values, "scorecard.value"),
      mission: get(values, "mission"),
      vision: get(values, "vision"),
      owner_id: get(owner, "id"),
      notes: get(values, "notes"),
    };
    !isAddMode
      ? updateReq(`${STRATEGYMAP_URL}/${id}`, payload)
      : postStrategymap(STRATEGYMAP_URL, payload);
  };

  useEffect(() => {
    if (!isAddMode) {
      const { complete, pending, data, error } = updateRes;
      if (!pending && complete && data) {
        closeModal();
        toast.success("Updated successfully!");
      } else if (error) {
        toast.error("Update failed!");
      }
    } else {
      const { complete, pending, data, error } = postRes;
      if (!pending && complete && data) {
        closeModal();
        toast.success("Added successfully!");
      } else if (error) {
        toast.error("Adding new strategy map failed!");
      }
    }
  }, [closeModal, updateRes, postRes]);

  const initialValues = {
    name: get(editData, "name", ""),
    period: get(editData, ""),
    notes: get(editData, "notes", ""),
    mission: get(editData, "mission", ""),
    vision: get(editData, "vision", ""),
    scorecard: scorecardOptions.filter(
      (scard) => scard.value === get(editData, "scorecard_id")
    ),
  };
  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      onSubmit={submitForm}
    >
      {() => {
        return (
          <Form>
            <InputSection>
              <Field
                type="text"
                name="name"
                placeholder="enter strategymap name"
                label="Strategymap name"
                component={Input}
              />
            </InputSection>
            <InputSection>
              <Field
                name="scorecard"
                dropdownLabel="Scorecard"
                component={DropDown}
                options={scorecardOptions}
                width="97%"
                isBordered={true}
              />
            </InputSection>
            <InputSection>
              <Field
                type="textarea"
                name="mission"
                placeholder="Mission statement"
                label="Mission statement"
                component={Input}
              />
            </InputSection>
            <InputSection>
              <Field
                type="textarea"
                name="vision"
                placeholder="Vission statement"
                label="Vission statement"
                component={Input}
              />
            </InputSection>
            <InputSection>
              <Field
                type="textarea"
                name="notes"
                height="6em"
                placeholder="Notes"
                label="Notes"
                component={Input}
              />
            </InputSection>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddStrategymapForm;

const OwnerSection = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  justify-content: space-between;
  margin-top: 1em;
  ${TitleText} {
    text-align: end;
  }
`;

const SelectedOwner = styled.div`
  display: grid;
  grid-template-columns: 3fr 0.1fr;
  align-items: center;
  ${LabelText} {
    grid-column: 1 / span 2;
  }
`;
